/* MomProStore theme scripts (scoped to .mps-* markup) */
(function () {
  'use strict';
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* Scroll reveal */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mps-reveal:not(.mps-in)');
    if (!els.length) return;
    if (designMode || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('mps-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('mps-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Header: mobile menu + search toggle */
  function initHeader(root) {
    (root || document).querySelectorAll('.mps-header').forEach(function (h) {
      var toggle = h.querySelector('.mps-menu-toggle'), mobile = h.querySelector('.mps-mobile-nav');
      if (toggle && mobile && !toggle.dataset.bound) {
        toggle.dataset.bound = '1';
        toggle.addEventListener('click', function () {
          var open = mobile.classList.toggle('mps-open');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          h.querySelector('.mps-search-bar') && h.querySelector('.mps-search-bar').classList.remove('mps-open');
        });
      }
      var sBtn = h.querySelector('.mps-search-toggle'), sBar = h.querySelector('.mps-search-bar');
      if (sBtn && sBar && !sBtn.dataset.bound) {
        sBtn.dataset.bound = '1';
        sBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var open = sBar.classList.toggle('mps-open');
          sBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open) { var i = sBar.querySelector('input[type="search"]'); i && i.focus(); }
        });
      }
    });
  }

  /* Best-sellers carousel arrows */
  function initCarousels(root) {
    (root || document).querySelectorAll('[data-mps-carousel]').forEach(function (wrap) {
      if (wrap.dataset.bound) return; wrap.dataset.bound = '1';
      var track = wrap.querySelector('.mps-carousel');
      function step(dir) { var card = track.querySelector('.mps-cw'); var w = card ? card.offsetWidth + 24 : 280; track.scrollBy({ left: dir * w, behavior: 'smooth' }); }
      var p = wrap.querySelector('[data-mps-prev]'), n = wrap.querySelector('[data-mps-next]');
      p && p.addEventListener('click', function () { step(-1); });
      n && n.addEventListener('click', function () { step(1); });
    });
  }

  /* Video review overlay */
  function initVideo(root) {
    (root || document).querySelectorAll('.mps-video-wrap').forEach(function (w) {
      if (w.dataset.bound) return; w.dataset.bound = '1';
      var v = w.querySelector('video'), play = w.querySelector('.mps-video-play');
      if (!v || !play) return;
      play.addEventListener('click', function () { v.play(); play.classList.add('mps-hidden'); });
      v.addEventListener('play', function () { play.classList.add('mps-hidden'); });
      v.addEventListener('pause', function () { play.classList.remove('mps-hidden'); });
    });
  }

  /* Soft wishlist (localStorage) — used only when the Swym Wishlist Plus app is not running */
  var WKEY = 'mps_wishlist';
  function wl() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function wlSave(a) { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} }
  function wlRender() {
    var n = wl().length;
    document.querySelectorAll('.mps-wish-count').forEach(function (c) { c.textContent = n; if (n > 0) c.removeAttribute('hidden'); else c.setAttribute('hidden', ''); });
    document.querySelectorAll('.mps-btn-wish[data-product-id]').forEach(function (b) {
      b.setAttribute('aria-pressed', wl().indexOf(b.dataset.productId) > -1 ? 'true' : 'false');
    });
  }
  function initWishlist(root) {
    (root || document).querySelectorAll('.mps-btn-wish[data-product-id]').forEach(function (b) {
      if (b.dataset.bound) return; b.dataset.bound = '1';
      b.addEventListener('click', function (e) {
        if (window._swat) return; // Swym handles it
        e.preventDefault();
        var id = b.dataset.productId, list = wl(), i = list.indexOf(id);
        if (i > -1) list.splice(i, 1); else list.push(id);
        wlSave(list); wlRender();
      });
    });
    wlRender();
  }

  /* Product page: gallery, variant picker, qty, sticky bar, added feedback */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-mps-product]').forEach(function (sec) {
      if (sec.dataset.bound) return; sec.dataset.bound = '1';
      var main = sec.querySelector('.mps-main-img');
      sec.querySelectorAll('.mps-thumb').forEach(function (t) {
        t.addEventListener('click', function () {
          sec.querySelectorAll('.mps-thumb').forEach(function (x) { x.classList.remove('mps-active'); });
          t.classList.add('mps-active');
          var vt = t.querySelector('template[data-video]');
          if (vt) {
            var dv = document.createElement('div');
            dv.innerHTML = vt.innerHTML;
            var nv = dv.firstElementChild;
            if (main) { main.replaceWith(nv); } else { sec.querySelector('.mps-gallery').prepend(nv); }
            main = nv;
          } else {
            var ni = document.createElement('img');
            ni.className = 'mps-main-img';
            ni.alt = t.alt || '';
            ni.src = t.dataset.full || t.src || '';
            if (t.dataset.srcset) { ni.srcset = t.dataset.srcset; }
            if (main) { main.replaceWith(ni); } else { sec.querySelector('.mps-gallery').prepend(ni); }
            main = ni;
          }
        });
      });

      /* Quantity */
      sec.querySelectorAll('.mps-qty').forEach(function (q) {
        var inp = q.querySelector('input');
        q.querySelector('[data-minus]').addEventListener('click', function () { inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) - 1); inp.dispatchEvent(new Event('change')); });
        q.querySelector('[data-plus]').addEventListener('click', function () { inp.value = (parseInt(inp.value, 10) || 1) + 1; inp.dispatchEvent(new Event('change')); });
      });

      /* Variant selection */
      var dataEl = sec.querySelector('[data-mps-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var idInput = sec.querySelector('input[name="id"]');
      var priceEl = sec.querySelector('[data-mps-price]'), compareEl = sec.querySelector('[data-mps-compare]');
      var atc = sec.querySelector('.mps-btn-add[type="submit"]'), atcText = atc ? atc.querySelector('[data-mps-atc-text]') : null;
      var stickyPrice = sec.querySelector('[data-mps-sticky-price]');
      /* Some shops have HTML baked into their money format (e.g. "<span class=money> ${{amount}} </span>"
         from an old currency app). Since we write prices with textContent, that markup would show up as
         literal text on the page. Strip any tags before using the format. */
      var moneyFormat = (sec.dataset.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '').trim() || '${{amount}}';
      var stockEl = sec.querySelector('[data-mps-stock]');
      var threshold = parseInt(sec.dataset.lowStock || '5', 10);

      function money(cents) {
        var v = (cents / 100).toFixed(2);
        return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','));
      }
      function selectedOptions() {
        var opts = [];
        sec.querySelectorAll('[data-mps-option]').forEach(function (fs) {
          var c = fs.querySelector('input:checked'); opts.push(c ? c.value : null);
        });
        return opts;
      }
      function updateVariant() {
        if (!variants.length) return;
        var opts = selectedOptions();
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
        sec.querySelectorAll('[data-mps-option]').forEach(function (fs) {
          var label = fs.querySelector('.mps-opt-label span'); var c = fs.querySelector('input:checked');
          if (label && c) label.textContent = c.value;
        });
        if (!v) {
          if (atc) { atc.setAttribute('aria-disabled', 'true'); atc.disabled = true; atcText && (atcText.textContent = atc.dataset.unavailable || 'Unavailable'); }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        if (compareEl) { if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; } else compareEl.hidden = true; }
        if (atc) {
          if (v.available) { atc.removeAttribute('aria-disabled'); atc.disabled = false; atcText && (atcText.textContent = atc.dataset.add || 'Add to Cart'); }
          else { atc.setAttribute('aria-disabled', 'true'); atc.disabled = true; atcText && (atcText.textContent = atc.dataset.soldOut || 'Sold out'); }
        }
        if (stockEl) {
          if (v.managed && v.available && v.qty > 0 && v.qty <= threshold) { stockEl.textContent = stockEl.dataset.low.replace('[count]', v.qty); stockEl.hidden = false; stockEl.classList.remove('mps-instock'); }
          else if (v.available && stockEl.dataset.instock) { stockEl.textContent = stockEl.dataset.instock; stockEl.hidden = false; stockEl.classList.add('mps-instock'); }
          else stockEl.hidden = true;
        }
        if (v.featured_media_id && main) {
          var t = sec.querySelector('.mps-thumb[data-media-id="' + v.featured_media_id + '"]'); if (t) t.click();
        }
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url);
      }
      sec.querySelectorAll('[data-mps-option] input').forEach(function (i) { i.addEventListener('change', updateVariant); });
      if (variants.length > 1) updateVariant();

      /* Custom (line-item property) pickers just update their label */
      sec.querySelectorAll('[data-mps-property]').forEach(function (fs) {
        fs.querySelectorAll('input').forEach(function (i) {
          i.addEventListener('change', function () { var l = fs.querySelector('.mps-opt-label span'); if (l) l.textContent = i.value; });
        });
      });

      /* Added feedback (Dawn product-form handles the AJAX add) */
      var form = sec.querySelector('form[data-type="add-to-cart-form"]');
      if (form && atc) {
        form.addEventListener('submit', function () {
          var check = setInterval(function () {
            if (!atc.classList.contains('loading')) {
              clearInterval(check);
              if (atc.disabled) return;
              var errBox = sec.querySelector('.product-form__error-message-wrapper');
              if (errBox && !errBox.hidden) return;
              atc.classList.add('mps-added'); var orig = atcText ? atcText.textContent : '';
              atcText && (atcText.textContent = atc.dataset.added || 'Added ✓');
              setTimeout(function () { atc.classList.remove('mps-added'); atcText && (atcText.textContent = orig); }, 1800);
            }
          }, 120);
        });
      }

      /* Sticky mobile bar */
      var sticky = sec.querySelector('.mps-sticky-atc'), buyRow = sec.querySelector('.mps-buy-row');
      if (sticky && buyRow && 'IntersectionObserver' in window) {
        var io2 = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) sticky.classList.remove('mps-show');
            else if (window.scrollY > buyRow.offsetTop + 140) sticky.classList.add('mps-show');
          });
        }, { threshold: 0 });
        io2.observe(buyRow);
        var sBtn = sticky.querySelector('button');
        sBtn && sBtn.addEventListener('click', function () { if (atc && !atc.disabled) atc.click(); });
      }
    });
  }

  function initAll(root) { initReveal(root); initHeader(root); initCarousels(root); initVideo(root); initWishlist(root); initProduct(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* Theme editor: re-init when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
